export default "__VITE_ASSET__BkfNG$p3__"